var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('b-row',[_c('b-col',{staticClass:"logo"},[_c('Logo')],1),_c('b-col',{staticClass:"hacienda"},[_c('Hacienda')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }